import React from 'react';
import styled from 'styled-components';

import Picture from '../../../../containers/assets/instructor-onboarding-image20.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;
`;

const Container = styled.div`
  padding: 40px;
  width: 80%;
  max-width: 794px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Text3 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 12px;

  b {
    color: #ed716d;

    &.black-note {
      color: rgba(0, 27, 59, 0.94);
    }
  }
`;

const Image = styled.div`
  display: flex;
  margin-top: 12px;
`;

const WhatToExpectStep4 = () => (
  <Wrapper>
    <Container>
      <Text1>What To Expect</Text1>
      <Text2>Round 3 | Accounting &amp; Finance disciplines are emphasized</Text2>
      <Text3>
        In round 3, finance &amp; accounting comes into more focus as return on investment
        metrics are introduced (ROE, ROA). In other words, teams will have to make a profit.
      </Text3>

      <Image>
        <img src={Picture} alt="" />
      </Image>

      <Text3>
        To better their odds, your students will need to spend time analyzing their prior
        round financials as well as consider new financing options to maximize their chance
        of hitting those metrics (e.g. share buybacks).
      </Text3>
    </Container>
  </Wrapper>
);

export default WhatToExpectStep4;



// WEBPACK FOOTER //
// ./src/instructor/components/onboarding/what-to-expect/step4.js